module.exports = __webpack_public_path__ + "img/right-leg.169e0b37.png";